import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/congress")({
  component: CongressLayoutRoute,
})

function CongressLayoutRoute() {
  return <Outlet />
}
